import React from 'react';
import { link } from '../../lib/loc.js';

export const Link = ({ href, preClick, children, ...props }) => (
  <a
    href={href}
    {...props}
    onClick={evt => {
      evt.preventDefault();
      if (preClick) {
        preClick(evt);
      }
      link(href);
    }}
  >{children}</a>
);

